import React, { Component } from "react";
import _ from 'lodash';

// UI Components
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { getMessage } from "CONFIG/i18n";

import "../AdminDashboard.less";
import "./SessionList.less";

import { getBootstrapTableOptions } from "UTILS/Utility";

export default class smsSendNumber extends Component{

  constructor(props){
    super(props);
    this.state={
      showSessionDetailsFlag: 1,
    };
  }

  showSessionDetails = () =>{
    this.setState({ showSessionDetailsFlag : 0 });
  }

  fetchAggregationItems = (cell, row) => {
    return (
      <div>
        <label
          className="nameEllipsis"
          title={row.sms_send_month}
        >
          {getMessage(row.sms_send_month)}
        </label>
      </div>
    )
  }

  fetchIssuanceCount = (cell, row) => {
    return (
      <div>
        <label
          title={row.sms_count}>
          {row.sms_count}
        </label>
      </div>
    )
  }

  render(){
    const { smsSendNumPageNo, smsSendNumList, sessionsCount } = this.props;
    const displayPage = smsSendNumPageNo + 1;
    return(
      (this.state.showSessionDetailsFlag) ?
        <div className="reportListContainer">
          <BootstrapTable
            keyField="sms_send_month"
            data={smsSendNumList}
            tableHeaderClass="tableHeader"
            tableBodyClass='tableBody'
            containerClass='organisationsList reportList'
            tableContainerClass=''
            headerContainerClass=''
            bodyContainerClass=''
            bordered={false}
            options={getBootstrapTableOptions()}
            printable
          >
            <TableHeaderColumn
              dataField='session_key'
              hidden={true}
            >
              {getMessage("SESSION_KEY")}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.fetchAggregationItems}
            >
              {getMessage("AGGREGATION_ITEMS")}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.fetchIssuanceCount}
            >
              {getMessage("ISSUANCE_COUNT")}
            </TableHeaderColumn>
          </BootstrapTable>

        </div>:null
    )

  }

}
